import React from "react";
import { motion } from "framer-motion";
import { REVEAL } from "@/lib/motion";
import AuditForm from "@/components/AuditForm";

const BENEFITS = [
  { figure: "30", unit: "minutes", text: "on a call" },
  { figure: "4", unit: "areas", text: "of your sales process reviewed" },
  { figure: "48", unit: "hours", text: "to your one-page summary" },
  { figure: "3", unit: "biggest gaps", text: "and what we'd fix first" },
];

export const HomeAudit = () => (
  <section id="audit-form" className="bg-[#3D472D] px-6 sm:px-8 py-20 sm:py-28 scroll-mt-20" data-testid="home-audit">
    <div className="max-w-5xl mx-auto grid lg:grid-cols-[0.9fr_1.1fr] gap-12 lg:gap-16 items-start">
      <motion.div {...REVEAL}>
        <h2 className="font-fraunces font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#F4E9D8] leading-tight">
          Book your free sales audit
        </h2>
        <ul className="mt-10 space-y-6">
          {BENEFITS.map((b, i) => (
            <li key={b.text} className="flex items-baseline gap-4" data-testid={`audit-benefit-${i + 1}`}>
              <span className="font-fraunces font-extrabold text-3xl text-[#C8703A] w-12 shrink-0">{b.figure}</span>
              <span className="text-sm md:text-base text-[#F4E9D8]/80 leading-relaxed">
                <span className="font-semibold text-[#F4E9D8]">{b.unit}</span> {b.text}
              </span>
            </li>
          ))}
        </ul>
      </motion.div>

      <motion.div {...REVEAL}>
        <AuditForm onDark />
      </motion.div>
    </div>
  </section>
);

export default HomeAudit;
